const tagsColors = [
    'pink',
    'red',
    'yellow',
    'orange',
    'cyan',
    'green',
    'blue',
    'purple',
    'geekblue',
    'magenta',
    'volcano',
    'gold',
    'lime',
];

export const getTagColor = (name: string) => {
    const nameSize = name.length;
    const numberOfColors = tagsColors.length;
    const result = nameSize % numberOfColors;
    return result < numberOfColors ? tagsColors[result] : tagsColors[numberOfColors - 1];
};
